module.exports = __webpack_public_path__ + "media/1.66004470.mp3";